import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=0ccff770&scoped=true"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccff770",
  null
  
)

export default component.exports